import React from 'react';
import { Col, Row } from 'components';
import { ContactPerson } from 'feature';
import { HasAccess } from 'components/common/accessControl';
import { PERMISSIONS } from 'constants/permissions';
import { CompetitorSupplier } from './competitorSupplier';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

export const SupplierGeneral = React.memo(() => {
  const { hasAccess } = useAccessControl();
  return (
    <Row wrap={false} className={'gap-32'}>
      <Col flex={'566px'}>
        <HasAccess role={PERMISSIONS.suppliers.contact_person.read}>
          <ContactPerson
            hasAccessToWrite={hasAccess(PERMISSIONS.suppliers.contact_person.write)}
            hasAccessToDelete={hasAccess(PERMISSIONS.suppliers.contact_person.delete)}
            entityName={'SUPPLIER'}
          />
        </HasAccess>
      </Col>
      <Col flex={'362px'}>
        <HasAccess role={PERMISSIONS.suppliers.competitor_suppliers.read}>
          <CompetitorSupplier />
        </HasAccess>
      </Col>
    </Row>
  );
});
